// csvUtils.js
import Papa from "papaparse";

export function CsvToJsonConverter(filePath) {
  return fetch(filePath)
    .then((response) => response.text())
    .then((csvText) => {
      return new Promise((resolve, reject) => {
        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: function (results) {
            resolve(results.data);
          },
          error: function (err) {
            reject(err);
          },
        });
      });
    });
}
